import { connect } from 'react-redux';
import { getUserRole, getIsUserInListerMode } from 'datamodel/User/selectors';
import { getToken, getUserId } from 'datamodel/Auth/selectors';

import ChatsBrowser from './chats-browser';
import { getInboxRoomTitle } from 'datamodel/Inbox/selectors';

const mapStateToProps = (state) => ({
  userId: getUserId(state),
  token: getToken(state),
  userRole: getUserRole(state),
  roomTitle: getInboxRoomTitle(state),
  isUserInListerMode: getIsUserInListerMode(state),
});

export default connect(mapStateToProps)(ChatsBrowser);
